import type { ILoginModel } from "@/components/screens/login/types/login";
import ForgotPasswordAlert from "../components/login/forgot-password";
import LoginActions from "../components/login/actions";
import LoginFooter from "../components/login/footer";
import LoginFormInputs from "../components/login/form";
import OTP from "../components/login/otp";

const LoginScreen = ({ vm }: { vm: ILoginModel }) => (
  <>
    <div className="flex min-h-screen flex-col justify-center bg-dines-purple-darkest">
      <div className="mt-10 flex w-full justify-center">
        <div className="w-full px-5 sm:w-[30rem]">
          <div className="mb-5 text-white">
            {vm.labels.subtitles.map((subtitle) => (
              <span
                className="font-bold text-sm uppercase opacity-60 sm:text-lg"
                onClick={subtitle.onClick && subtitle.onClick}
                onKeyDown={subtitle.onClick && subtitle.onClick}
                key={subtitle.key}
              >
                {subtitle.title}
              </span>
            ))}

            <h1 className="mt-1 whitespace-nowrap font-bold text-3xl text-dines-green sm:text-5xl">
              {vm.labels.title}
            </h1>
          </div>
          <form>
            {vm.OTPViewModel.showOTPSection && <OTP vm={vm.OTPViewModel} />}

            {!vm.forgotPasswordAlert.showAlert &&
              !vm.OTPViewModel.showOTPSection && (
                <LoginFormInputs vm={vm.formInputsViewModel} />
              )}

            {vm.forgotPasswordAlert.showAlert &&
              !vm.OTPViewModel.showOTPSection && (
                <ForgotPasswordAlert vm={vm.forgotPasswordAlertViewModel} />
              )}
            {!vm.forgotPasswordAlert.showAlert &&
              !vm.OTPViewModel.showOTPSection && (
                <LoginActions vm={vm.actionsViewModel} />
              )}
          </form>
          <LoginFooter vm={vm.footerViewModel} />
        </div>
      </div>
    </div>
  </>
);

export default LoginScreen;
